import { render, staticRenderFns } from "./AchievementCreate.vue?vue&type=template&id=27df56a9&scoped=true"
import script from "./AchievementCreate.vue?vue&type=script&lang=js"
export * from "./AchievementCreate.vue?vue&type=script&lang=js"
import style0 from "./AchievementCreate.vue?vue&type=style&index=0&id=27df56a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df56a9",
  null
  
)

export default component.exports